import type { AppStore } from "@/store";
import { trackEvent, TrackedEvent } from "@/domains/metrics";
import { SubscriptionPlanKind } from "@/store/subscriptions/types";

/**
 * Tracks the floating Mem Agent header Upgrade button. Always fired from the
 * renderer that owns subscription state — the main one on desktop, since the
 * widget window is a separate renderer.
 */
export const trackFloatingAgentUpgradeButtonClicked = ({ store }: { store: AppStore }): void => {
  const currentPlanKind =
    store.subscriptions.billingDisplayPlanKind ??
    store.subscriptions.featureAccess?.planKind ??
    SubscriptionPlanKind.UNKNOWN;

  trackEvent(TrackedEvent.FloatingAgentUpgradeButtonClicked, {
    source: "floating_agent_upgrade_button",
    current_plan_kind: currentPlanKind,
    effective_plan_kind: store.subscriptions.effectiveDisplayPlanKind ?? currentPlanKind,
    target_plan_kind: SubscriptionPlanKind.PROACTIVE,
    is_proactive_trial_eligible: store.subscriptions.isProactiveTrialEligible,
  });
};
